import { render, staticRenderFns } from "./tuoiPagamenti.vue?vue&type=template&id=7c3ae6e2&"
import script from "./tuoiPagamenti.vue.ts?vue&type=script&lang=js&"
export * from "./tuoiPagamenti.vue.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports